import React from "react";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

export default function FloatingWhatsapp() {
    const { settings } = useSettings();
    return (
        <a
            href={whatsappLink(settings.whatsapp_number, "Hello Singh Jewellers, I'd like to enquire about your jewellery.")}
            target="_blank" rel="noreferrer"
            data-testid="floating-whatsapp"
            className="fixed bottom-24 lg:bottom-8 right-5 lg:right-8 z-40 w-14 h-14 rounded-full bg-[color:var(--whatsapp)] text-white flex items-center justify-center shadow-2xl hover:scale-110 transition-transform"
            aria-label="Chat on WhatsApp"
        >
            <MessageCircle size={26} />
            <span className="absolute inset-0 rounded-full bg-[color:var(--whatsapp)]/50 animate-ping" />
        </a>
    );
}
